import React from 'react';
import PhoneIllustration from './PhoneIllustration';
import VelaBriefCard from '../Overview/VelaBriefCard';
import { PAYMENT_LINKS_VELA_BRIEFS } from '../data';

const H1: React.CSSProperties = { fontSize: 26, fontWeight: 800, margin: '0 0 6px', color: '#0E1A1A' };
const SUB: React.CSSProperties = { margin: 0, fontSize: 14, color: '#66748B', maxWidth: 560 };
const PAGE_HEAD: React.CSSProperties = {
  display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
  gap: 24, marginBottom: 22,
};
const BTN: React.CSSProperties = {
  display: 'inline-flex', alignItems: 'center', gap: 8,
  background: '#0E1A1A', color: '#FFFFFF',
  fontSize: 14, fontWeight: 600, padding: '11px 18px',
  borderRadius: 10, border: 0, cursor: 'pointer',
  boxShadow: '0 2px 6px rgba(14,26,26,.12)',
};
const BTN_GHOST: React.CSSProperties = {
  ...BTN, background: '#FFFFFF', color: '#0E1A1A',
  border: '1px solid #E7EAF0', boxShadow: 'none',
};
const TOOLBAR: React.CSSProperties = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
  background: '#FFFFFF', border: '1px solid #E7EAF0',
  borderRadius: '14px 14px 0 0', padding: '12px 18px', borderBottom: 0,
};
const CHIP_ROW: React.CSSProperties = { display: 'flex', gap: 8 };
const CHIP: React.CSSProperties = {
  fontSize: 12.5, padding: '6px 12px', borderRadius: 999,
  color: '#66748B', background: '#F7F8FA', cursor: 'pointer',
};
const CHIP_ACTIVE: React.CSSProperties = {
  ...CHIP, background: '#0E1A1A', color: '#FFFFFF', fontWeight: 600,
};
const EMPTY_CARD: React.CSSProperties = {
  background: '#FFFFFF', border: '1px solid #E7EAF0', borderTop: 0,
  borderRadius: '0 0 14px 14px',
  display: 'flex', alignItems: 'stretch', overflow: 'hidden',
};
const ILL_WRAP: React.CSSProperties = {
  flex: '0 0 auto',
  padding: '48px 36px',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: '#FFFFFF',
};
const COPY: React.CSSProperties = {
  flex: 1,
  padding: '52px 48px 60px',
  background: '#E8F5F2',
  display: 'flex', flexDirection: 'column', justifyContent: 'center',
};
const COPY_H2: React.CSSProperties = { fontSize: 30, fontWeight: 800, margin: '0 0 14px', lineHeight: 1.15 };
const COPY_P: React.CSSProperties = { fontSize: 15, color: '#66748B', lineHeight: 1.65, margin: '0 0 22px' };
const STEPS: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: 14, margin: '22px 0 26px' };
const STEP: React.CSSProperties = {
  display: 'flex', alignItems: 'flex-start', gap: 12,
  fontSize: 13.5, color: '#0E1A1A', lineHeight: 1.5,
};
const STEP_N: React.CSSProperties = {
  width: 22, height: 22, background: '#FFFFFF', color: '#0F6E56',
  borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontWeight: 800, fontSize: 11, flexShrink: 0, marginTop: 1,
};

const steps = [
  { b: 'Turn on Novala Pay', d: 'Takes 2 minutes. Cards, bank transfers, Interac e-Transfer.' },
  { b: 'Create a payment link', d: 'One link, any amount, reusable or one-time.' },
  { b: 'Send it where your customers are', d: 'Text, email, invoice footer, or print the QR for in-person.' },
];

export default function PaymentLinks() {
  return (
    <div>
      <div style={PAGE_HEAD}>
        <div>
          <h1 style={H1}>Payment links</h1>
          <p style={SUB}>
            Create a reusable link or a one-off invoice link. Share it in email, text, or on your site. Money lands in your Novala account.
          </p>
        </div>
        <button type="button" style={BTN}>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.4">
            <path d="M12 5v14M5 12h14" />
          </svg>
          Create payment link
        </button>
      </div>

      {PAYMENT_LINKS_VELA_BRIEFS.map((brief) => (
        <VelaBriefCard key={brief.id} brief={brief} />
      ))}

      <div style={TOOLBAR}>
        <div style={CHIP_ROW}>
          <div style={CHIP_ACTIVE}>All links</div>
          <div style={CHIP}>Active</div>
          <div style={CHIP}>Paid</div>
          <div style={CHIP}>Expired</div>
        </div>
      </div>
      <div style={EMPTY_CARD}>
        <div style={ILL_WRAP}>
          <PhoneIllustration />
        </div>
        <div style={COPY}>
          <h2 style={COPY_H2}>Share a link, get paid.</h2>
          <p style={COPY_P}>
            Create a reusable payment link for a product, a service, or a one-off invoice. Send it in email or text. Your customer taps and pays in seconds.
          </p>
          <div style={STEPS}>
            {steps.map((s, i) => (
              <div key={i} style={STEP}>
                <span style={STEP_N}>{i + 1}</span>
                <div>
                  <div style={{ fontWeight: 700 }}>{s.b}</div>
                  <div style={{ color: '#66748B', fontSize: 13 }}>{s.d}</div>
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <button type="button" style={BTN}>Create payment link</button>
            <button type="button" style={BTN_GHOST}>See how it works</button>
          </div>
        </div>
      </div>
    </div>
  );
}